export { pickAccessibilityProps } from './pickAccessibilityProps';
